import { useContext } from "react";
import ThemeContext from "blocks/theme/theme-context";

export default () => useContext(ThemeContext);
